/**
 * GameBreaker Mega Menu — Hover Swap (Fixed)
 * assets/mega-menu-gb.js
 *
 * Fixes:
 *  1. Uses event DELEGATION on document — works even when mega menu
 *     HTML is injected later by the Section Rendering API.
 *     No more "bind too early, links don't exist yet" race condition.
 *  2. Finds the correct wrapper by traversing up from the hovered link.
 *  3. Also patches pointer-events so sidebar links are clickable
 *     inside the theme's pointer-events:none mega-menu wrapper.
 *
 * Add before </body> in theme.liquid:
 *   {{ 'mega-menu-gb.js' | asset_url | script_tag }}
 */

(function () {
  'use strict';

  var DELAY = 60; // ms hover delay — prevents flicker on fast mouse-through
  var timer = null;

  /* ── Find closest ancestor matching selector ─────────────── */
  function closest(el, selector) {
    if (el.closest) return el.closest(selector);
    while (el && el !== document) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentNode;
    }
    return null;
  }

  /* ── Activate a tab within a wrapper ─────────────────────── */
  function activate(wrapper, tabHandle) {
    if (!wrapper || !tabHandle) return;

    /* Sidebar links */
    wrapper.querySelectorAll('.mega-menu__gb-link[data-gb-tab]').forEach(function (l) {
      var active = l.dataset.gbTab === tabHandle;
      l.classList.toggle('is-active', active);
    });

    /* Product panels */
    wrapper.querySelectorAll('.mega-menu__gb-panel[data-gb-panel]').forEach(function (p) {
      var active = p.dataset.gbPanel === tabHandle;
      p.classList.toggle('is-active', active);
      p.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    /* Update "View All" link + text */
    var activeLink = wrapper.querySelector('.mega-menu__gb-link[data-gb-tab="' + tabHandle + '"]');
    var viewAll    = wrapper.querySelector('[data-gb-viewall]');
    var viewAllTxt = viewAll && wrapper.querySelector('[data-gb-viewall-text]');

    if (activeLink && viewAll) {
      viewAll.setAttribute('href', activeLink.dataset.gbUrl || '#');
    }
    if (activeLink && viewAllTxt) {
      var count = activeLink.dataset.gbCount;
      viewAllTxt.textContent =
        'All ' + (activeLink.dataset.gbLabel || '') +
        (count && parseInt(count) > 0 ? ' (' + count + ')' : '');
    }
  }

  /* ── Global delegated mouseover on document ──────────────── 
     This fires regardless of when the mega menu HTML was injected.
     Works with Section Rendering API lazy-loaded content.
     ─────────────────────────────────────────────────────────── */
  document.addEventListener('mouseover', function (e) {
    var link = closest(e.target, '.mega-menu__gb-link[data-gb-tab]');
    if (!link) return;

    clearTimeout(timer);
    var tab     = link.dataset.gbTab;
    var wrapper = closest(link, '.mega-menu__gb');
    if (!tab || !wrapper) return;

    timer = setTimeout(function () {
      activate(wrapper, tab);
    }, DELAY);
  });

  /* Cancel pending timer when mouse leaves a link */
  document.addEventListener('mouseout', function (e) {
    var link = closest(e.target, '.mega-menu__gb-link[data-gb-tab]');
    if (link) clearTimeout(timer);
  });

  /* Focus support for keyboard navigation */
  document.addEventListener('focusin', function (e) {
    var link = closest(e.target, '.mega-menu__gb-link[data-gb-tab]');
    if (!link) return;
    var tab     = link.dataset.gbTab;
    var wrapper = closest(link, '.mega-menu__gb');
    if (tab && wrapper) activate(wrapper, tab);
  });

  /* ── Pointer-events fix ──────────────────────────────────── 
     The theme sets pointer-events:none on .mega-menu wrapper div.
     This runs once after page load and re-enables pointer events
     on the GameBreaker container so hover/click works.
     CSS also handles this but belt-and-suspenders here.
     ─────────────────────────────────────────────────────────── */
  function fixPointerEvents() {
    document.querySelectorAll('.mega-menu__container--gb').forEach(function (el) {
      el.style.pointerEvents = 'auto';
      /* Walk up and fix any pointer-events:none ancestors
         stopping at the details element (mega menu trigger) */
      var parent = el.parentElement;
      while (parent && !parent.hasAttribute('is')) {
        if (getComputedStyle(parent).pointerEvents === 'none') {
          parent.style.pointerEvents = 'auto';
        }
        parent = parent.parentElement;
      }
    });
  }

  /* ── Run on load + after Section Rendering API injections ─── */
  function init() {
    fixPointerEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run after Shopify section loads (Section Rendering API) */
  document.addEventListener('shopify:section:load', init);

  /* MutationObserver — catches api-button injecting mega content */
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      var needsFix = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          /* Check if the added node contains a GB mega menu */
          if (
            (node.classList && node.classList.contains('mega-menu__container--gb')) ||
            (node.querySelector && node.querySelector('.mega-menu__container--gb'))
          ) {
            needsFix = true;
          }
        });
      });
      if (needsFix) fixPointerEvents();
    }).observe(document.body, { childList: true, subtree: true });
  }

})();
